<template>
    <div class="modal fade  bs-example-modal-lg" id="new-offer">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body">
                    <div class="col-xs-12">
                        <h2 class="pull-left">{{ operation == "edit" ? "Editar Oferta" : "Nueva Oferta" }}</h2>
                        <i class="md md-star-outline star-ico pull-right"></i>
                    </div>
                    <div class="col-xs-12 col-lg-6 b-r b-grey">
                        <div :class="getClass(selectedType)">
                            <h5>Tipo de oferta<small class="text-danger">*</small></h5>
                            <select class="form-control" data-init-plugin="select2" v-model="selectedType">
                                <option v-for="TypeResult in type" :value="TypeResult.id">{{ TypeResult.name }}</option>
                            </select>
                        </div>
                        <div :class="getClass(selectedServiceType)">
                            <h5>Segmento<small class="text-danger">*</small></h5>
                            <select class="form-control" data-init-plugin="select2" v-model="selectedServiceType" number>
                                <option v-for="ServiceTypeResult in serviceType" :value="ServiceTypeResult.id">{{ ServiceTypeResult.name }}</option>
                            </select>
                        </div>
                        <div :class="getClass(selectedCategory)" v-show="selectedServiceType">
                            <h5>Categoría<small class="text-danger">*</small></h5>
                            <select class="form-control" data-init-plugin="select2" v-model="selectedCategory" number>
                                <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
                            </select>
                        </div>
                        <div :class="getClass(selectedProvider)">
                            <h5>Proveedor<small class="text-danger">*</small></h5>
                            <div class="form-group" data-init-plugin="select2">
                                <select class="form-control" v-model="selectedProvider">
                                    <option v-for="provider in providers" :value='provider.id'>{{ provider.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div :class="getClass(days)">
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <h5>Días<small class="text-danger">*</small></h5>
                            </div>
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <select class="form-control" data-init-plugin="select2" v-model="days">
                                    <option value="1">30</option>
                                    <option value="2">60</option>
                                    <option value="3">90</option>
                                </select>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div :class="getClass(fee)">
                            <div class="col-xs-12 col-lg-6 padding-0" style="display: none;">
                                <h5>Cuotas<small class="text-danger">*</small></h5>
                            </div>
                            <div class="col-xs-12 col-lg-6 padding-0" style="display: none;">
                                <input type="number" class='form-control' value="0" min="0" :max="feeLimit" v-model="fee" >
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div :class="getClass(days)" >
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <h5>Límite de Cuotas<small class="text-danger">*</small></h5>
                            </div>
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <input
                                    type="number"
                                    class='form-control'
                                    min="0"
                                    v-model="feeLimit"
                                   >
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div :class="getClass(amount)">
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <h5>Valor<small class="text-danger">*</small></h5>
                            </div>
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <input type="number" class='form-control' min="0" name="" v-model="amount">
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div :class="getClass(comission_percent)">
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <h5>Porcentaje de comisión<small class="text-danger">*</small></h5>
                            </div>
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <input type="number" class='form-control' min="0" v-model="comission_percent">
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div :class="getClass(discount_percent)">
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <h5>Porcentaje de descuento<small class="text-danger">*</small></h5>
                            </div>
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <input type="number" class='form-control' min="0" name="" v-model="discount_percent">
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div :class="getClass(cost)">
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <h5>Costo<small class="text-danger">*</small></h5>
                            </div>
                            <div class="col-xs-12 col-lg-6 padding-0">
                                <input type="number" class='form-control' min="0" name="" v-model="cost">
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="col-xs-12 padding-0">
                            <h5 class="bold">Vigencia</h5>
                            <div class="radio radio-default b-b b-grey p-b-10">
                                <div class="col-xs-12 col-lg-6 b-r b-grey text-center">
                                    <input type="radio" checked="checked" name="radio1" id="infinity" v-model='validity' value="0">
                                    <label for="infinity">Indefinida</label>
                                </div>
                                <div class="col-xs-12 col-lg-6 text-center">
                                    <input type="radio" name="radio1" id="temporal" v-model='validity' value="1">
                                    <label for="temporal">Temporal</label>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="col-xs-12 col-lg-6">
                                <label>Fecha de inicio<small class="text-danger">*</small></label>
                                <div class="input-group date">
                                    <input type="text" :class="[ !startDate && areFieldsRequired ? 'form-control border-red' : 'form-control']" placeholder="00/00/00" v-model="startDate" id="first-date">
                                    <span :class="[ !startDate && areFieldsRequired ? 'input-group-addon bg-white border-red' : 'input-group-addon bg-white']"><i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-lg-6">
                                <label class="text-disable">Fecha de vencimiento</label>
                                <div class="input-group" v-show="validity == '0'">
                                    <input type="text" class="form-control" placeholder="//" disabled>
                                    <span class="input-group-addon"><i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                                <div class="input-group" v-show="validity == '1'">
                                    <input type="text" :class="[ !due_date && areFieldsRequired ? 'form-control border-red' : 'form-control']" placeholder="//" v-model="due_date" id="last-date">
                                    <span :class="[ !startDate && areFieldsRequired ? 'input-group-addon border-red' : 'input-group-addon']"><i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <hr>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" value="1" v-model="internOffer">
                            <label>Oferta interna</label>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-6">
                        <div :class="[ !imageSrc && areFieldsRequired ? 'img-holder b-a b-grey b-dashed center border-red' : 'img-holder b-a b-grey b-dashed center']">
                            <label class="text-center dropzone">
                                <div class="drop-hov">
                                    <input type="file" @change="sync($event, 'imagen')" required/>
                                    <h4 class="text-success m-0" v-if="!imageSrc">
                                        <i class="md md-add-circle xl-ico"></i>
                                        <br>
                                        AGREGAR IMAGEN
                                    </h4>
                                    <div v-else="imageSrc">
                                        <img :src="imageSrc">
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div :class="getClass(title)">
                            <h5>Título<small class="text-danger">*</small></h5>
                            <input type="text" class="form-control" v-model="title">
                        </div>
                        <div :class="getClass(description)">
                            <h5>Descripción<small class="text-danger">*</small></h5>
                            <textarea type="text" class="form-control" v-model="description"></textarea>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
                <div class="modal-footer">
                    <div class="row">
                        <div class="col-xs-12 text-center">
                            <a :disabled="creatingUpdatingOffer" @click="areFieldsRequired = false" data-dismiss="modal" class="btn btn-default">CANCELAR</a>
                            <a :disabled="creatingUpdatingOffer" class="btn btn-default" @click="verifyRequiredFields()">
                                <span v-show="creatingUpdatingOffer" class="fa fa-spin fa-spinner"></span>
                                {{ operation == "edit" ? "EDITAR" : "CREAR" }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
    export default {
        name: 'create-edit-offer',
        props: {
            /**
             * Específica el tipo de contexto de la nota a crear (cobrar/pagar)
             */
            operation: {
                type: String,
                required: true
            },
            offer: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                amount: 0,
                cost: 0,
                categories: [],
                comission_percent: 0,
                description: '',
                discount_percent: 0,
                due_date: '',
                days: 0,
                fee: 0,
                feeLimit: 0,
                imagen: null,
                imageSrc: '',
                internOffer: 0,
                creatingUpdatingOffer: false,
                providers: [],
                selectedCategory: '',
                selectedProvider: '',
                selectedServiceType: '',
                selectedType: 0,
                serviceType: [],
                startDate: '',
                title: '',
                areFieldsRequired: false,
                type: [],
                validity: '0',
                imageNotFoundUrl: "http://3ie87c2dond928rt2e2zzo8o.wpengine.netdna-cdn.com/wp-content/themes/gonzo/images/no-image-featured-image.png",
                apiBase: apiUrl.replace('/v1', ''),
            }
        },
        watch: {
            'selectedServiceType': function() {
                if(this.selectedServiceType && this.serviceType.length) {
                    this.setCategories();
                }
            },
            'serviceType': function() {
                if(this.selectedServiceType && this.operation == "edit" && this.serviceType.length && this.categories) {
                    this.setCategories();
                }
            },
            'offer': function() {
                if(this.offer && this.operation == "edit") {
                    this.getOffer();
                } else {
                    this.cleanFields();
                }
            },
            'amount' : function() {
                this.cost = Number(this.amount) + (Number(this.comission_percent/100) * Number(this.amount));
            },
            'comission_percent' : function() {
                this.cost = Number(this.amount) + (Number(this.comission_percent/100) * Number(this.amount));
            },
            'fee' : function() {
                if (Number(this.fee) > Number(this.feeLimit)) {
                    //swal("Advertencia", "El número de cuotas no puede acceder el límite de cuotas", "warning");
                    this.fee = this.feeLimit;
                }
            }
        },
        created() {
            //this.getStatus();
            if (this.operation == "create") {
                this.cleanFields();
            }
            this.getProviders();
            this.getOfferType();
            this.getOfferServiceType();
        },
        ready() {
            $("#new-offer").on('show.bs.modal', () => {
                this.areFieldsRequired = false;
            });
        },
        methods: {
            createOffer: function() {
                let data = new FormData();

                data.append('title', this.title);
                data.append('description', this.description);
                data.append('start_date', moment(this.startDate).format("YYYY-MM-DD"));
                data.append('due_date', moment(this.due_date).format("YYYY-MM-DD"));
                data.append('validity', this.validity);
                data.append('comission_percent', this.comission_percent);
                data.append('discount_percent', this.discount_percent);
                data.append('status_id', 1);
                data.append('fee', this.fee);
                data.append('days_id', this.days);
                data.append('categories_id', this.selectedCategory);
                data.append('type_id', this.selectedType);
                data.append('service_type_id', this.selectedServiceType);
                data.append('provider_id', this.selectedProvider);
                data.append('intern', 1);
                data.append('image', this.imagen);
                data.append('amount', this.amount);
                data.append('cost', this.cost);

                this.creatingUpdatingOffer = true;

                this.$http({
                    emulateJSON: true,
                    emulateHTTP: true,
                    url: apiUrl + '/offers',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: data,
                }).then(function(response) {
                    swal("¡Listo!", "¡Oferta creada exitosamente!", "success");
                    $('#new-offer').modal('toggle');
                    this.cleanFields();
                    this.creatingUpdatingOffer = false;
                    this.$dispatch('reload-table');
                }, response => {
                    sweetAlert("Oops...", "¡Ha ocurrido un error al crear la oferta! " + response.status.message, "error");
                    this.creatingUpdatingOffer = false;
                });

                //get new data
                this.$broadcast('vuetable:reload');
            },
            cleanFields() {
                        this.title = "";
                        this.description = "";
                        this.startDate = "";
                        this.comission_percent = "";
                        this.discount_percent = "";
                        this.selectedCategory = "";
                        this.selectedType = 0;
                        this.selectedServiceType = 0;
                        this.selectedProvider = 0;
                        this.amount = 0;
                        this.cost = 0;
                        this.days = "";
                        this.fee = 0;
                        this.validity = 0;
                        this.due_date = "";
                        this.imageSrc = "";
            },
            getOffer() {
                this.amount = this.offer.amount;
                this.cost = this.offer.cost;
                this.categories = this.offer.categories;
                this.comission_percent = this.offer.comission_percent;
                this.description = this.offer.description;
                this.discount_percent = this.offer.discount_percent;
                if (this.offer.validity) {
                    this.due_date = this.offer.due_date;
                }
                this.days = this.offer.days_id;
                this.fee = this.offer.fee;
                this.imagen = this.offer.imagen;
                this.internOffer = this.offer.intern;
                this.selectedProvider = this.offer.provider_id;
                this.selectedServiceType = this.offer.service_type_id;
                this.selectedType = this.offer.type_id;
                this.selectedCategory = this.offer.categories_id;
                this.startDate = this.offer.start_date;
                this.title = this.offer.title;
                this.validity = this.offer.validity;
                this.imageSrc = this.getImageLink(this.offer);
            },
            getImageLink(offer) {
                if(offer.image) {
                    return `${this.apiBase}${offer.image}`;
                }
                return this.imageNotFoundUrl;
            },
            getOfferType: function() {
                this.$http.get(apiUrl + '/offer-types?q=(is_deleted:0)').then(response => {
                    this.type = response.data;
                }, response => {
                    sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
                });
            },
            getOfferServiceType: function() {
                this.$http.get(apiUrl + '/service-types?relationships=categories').then(response => {
                    this.serviceType = response.data;
                }, response => {
                    sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
                });
            },
            getProviders: function() {
                this.$http.get(apiUrl + '/providers').then(response => {
                    this.providers = response.data;
                }, response => {
                    sweetAlert("Oops...", "Ha ocurrido un error al cargar los proovedores !", "error");
                });
            },
            setCategories() {
                let service = this.serviceType.find(service => {
                    return service.id == this.selectedServiceType;
                });
                if (service && service.categories) {
                    this.categories = service.categories;
                }
            },
            sync: function(event, tipo) {
                event.preventDefault();
                this[tipo] = event.target.files[0] || event.dataTransfer.files[0];

                var image = new Image();
                var reader = new FileReader();
                var vm = this;
                reader.onload = (event) => {
                    vm.imageSrc = event.target.result;
                };

                reader.readAsDataURL(this[tipo]);
            },
            updateOffer: function() {
                let data = {};

                data.title = this.title;
                data.description = this.description;
                data.start_date = moment(this.startDate).format("YYYY-MM-DD");
                data.due_date = moment(this.due_date).format("YYYY-MM-DD");
                data.validity = this.validity;
                data.comission_percent = this.comission_percent;
                data.discount_percent = this.discount_percent;
                data.status_id = 1;
                data.fee = this.fee;
                data.days_id = this.days;
                data.categories_id = this.selectedCategory;
                data.type_id = this.selectedType;
                data.service_type_id = this.selectedServiceType;
                data.provider_id = this.selectedProvider;
                data.intern = 1;
                data.amount = this.amount;
                data.cost = this.cost;
                this.creatingUpdatingOffer = true;

                $.ajax({
                    url: apiUrl + `/offers/${this.offer.id}`,
                    type: 'PUT',
                    data: data,
                    contentType: 'application/x-www-form-urlencoded',
                    success: (data) => {
                        if (!this.imagen) {
                            swal("¡Listo!", "¡Oferta actualizada exitosamente!", "success");
                            $('#new-offer').modal('toggle');
                            this.$dispatch("updated-offer");
                            this.creatingUpdatingOffer = false;
                        } else {
                            let imageData = new FormData();
                            imageData.append('image',this.imagen);
                            this.$http({
                                emulateJSON: true,
                                emulateHTTP: true,
                                url: apiUrl + `/offers/${this.offer.id}/image`,
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: imageData,
                            }).then(function(response) {
                                swal("¡Listo!", "¡Oferta actualizada exitosamente!", "success");
                                $('#new-offer').modal('toggle');
                                this.$dispatch("updated-offer");
                                this.creatingUpdatingOffer = false;
                            }, response => {
                                sweetAlert("Oops...", "¡Ha ocurrido un error al actualizar la imagen! " + response.status.message, "error");
                                this.creatingUpdatingOffer = false;
                            });
                        }
                    },
                    error: function(data) {
                        sweetAlert("Oops...", "¡Ha ocurrido un error al actualizar la oferta! " + response.status.message, "error");
                        this.creatingUpdatingOffer = false;
                    }
                });
            },
            getClass(fieldValue) {
                if(!fieldValue && this.areFieldsRequired) {
                    return 'form-group has-error';
                }
                return 'form-group';
            },
            verifyRequiredFields() {
                let fields = this.title
                && this.description
                && this.startDate
                && this.comission_percent
                && this.discount_percent
                && this.selectedCategory
                && this.selectedType
                && this.selectedServiceType
                && this.selectedProvider
                && this.amount
                && this.cost
                && this.imageSrc;

                let requiredPaymentLoans = false;

                if (this.selectedType == "1" && !this.days) {
                    requiredPaymentLoans = true;

                } else if (this.selectedType == "2" && !this.fee) {
                    requiredPaymentLoans = true;
                }

                let requiredDueDate = Number(this.validity) && !this.due_date;

                if (fields && !requiredPaymentLoans && !requiredDueDate) {
                    if(this.operation == "edit") {
                        this.updateOffer();
                        this.areFieldsRequired = false;
                    } else {
                        this.createOffer();
                        this.areFieldsRequired = false;
                    }
                } else {
                    this.areFieldsRequired = true;
                    sweetAlert("Oops...", "¡Llene todos los campos requeridos!", "error");
                }
            }
        },
        computed: {
            deleteData: function() {
                if (this.selectedType == '1') {
                    return this.days = ''
                } else {
                    return this.fee = ''
                }
            }
        },
    }
</script>

<style scoped>
    .border-red {
        border-color: red;
    }
</style>



// WEBPACK FOOTER //
// create-edit-offers.vue?25aa6d38